import { Card } from 'react-bootstrap';
import { ArrowRight } from 'lucide-react';

const ProductCard = ({ producto, handleDetailModal }) => {
    return (
        <Card className="product-card border-0 shadow-sm rounded-0 h-100" style={{ cursor: 'pointer' }}
            onClick={() => handleDetailModal(producto)}>
            <div className="product-image-wrapper p-3">
                <Card.Img
                    variant="top"
                    src={producto.desktopRendition}
                    className="rounded-0 img-fluid"
                    style={{ objectFit: 'contain', height: '180px' }}
                />
            </div>
            <Card.Body className="pt-0 pb-5">
                {/*<small className="text-muted text-uppercase fw-bold">{producto.productName}</small>*/}
                <Card.Title className="fw-bold text-dark mt-1 mb-0 product-card-title">
                    {producto.productName}
                </Card.Title>

                <div className="arrow-button">
                    <ArrowRight size={18} color="white" />
                </div>
            </Card.Body>
        </Card>
    );
};

export default ProductCard;